const TILE_PREFIX = 'tile:';

export const isTileId = (id: string | undefined | null): boolean => {
  if (!id || !id.startsWith(TILE_PREFIX)) return false;
  const suffix = id.slice(TILE_PREFIX.length);
  if (suffix.length === 0) return false;
  const numeric = Number(suffix);
  return Number.isInteger(numeric) && numeric >= 0;
};

export const parseTileId = (id: string): number => Number(id.slice(TILE_PREFIX.length));

export const toTileId = (numericId: number): string => `${TILE_PREFIX}${numericId}`;
